declare namespace $ {

	export class $mol_icon_view_agenda extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=agenda.view.tree.d.ts.map